import { render, staticRenderFns } from "./BulkPriceUpdateModal.vue?vue&type=template&id=284add88&scoped=true&lang=html"
import script from "./BulkPriceUpdateModal.vue?vue&type=script&lang=js"
export * from "./BulkPriceUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./BulkPriceUpdateModal.vue?vue&type=style&index=0&id=284add88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284add88",
  null
  
)

export default component.exports